<template>
  <div v-if="user && selectedPackage">
    <!-- <button 
      type="button"
      class="btn btn-outline-success ml-1"
      data-toggle="modal"
      data-target="#packageProfile"
      data-backdrop="static"
      data-keyboard="false"
    >
      <font-awesome-icon icon="boxes" />
    </button> -->
    <div class="modal fade" id="packageProfile">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">OLAB ID: {{ selectedPackage.olab_id }}</h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <!-- .modal-header -->
          <div class="modal-body">
            <div v-if="selectedPackage.name" class="pt-2">
              <span class="font-italic">Name:</span>
              <span class="h5 text-dark ml-1">{{ selectedPackage.name }}</span>
              <span class="ml-2 font-italic">
                ({{ selectedPackage.package_type }} -
                {{ selectedPackage.package_seq_type }})
              </span>
            </div>

            <div class="py-1">
              <div class="card">
                <div class="card-header text-dark">Description</div>
                <div class="card-body">
                  <div class="py-1">
                    <span class="font-italic text-dark">{{
                      selectedPackage.desc
                    }}</span>
                  </div>
                  <!-- <div class="py-1 font-italic text-dark">
                    This is a CJCJ prototype of OLAB Bioscience Informatics
                  </div> -->
                </div>
                <!-- .card-body -->
              </div>
              <!-- .card -->
            </div>
            <div v-if="selectedPackage" class="py-1">
              <div class="card">
                <div class="card-header text-dark">Components</div>
                <div class="card-body">
                  <div v-if="selectedPackage.comps">
                    <div class="list-group list-group-flush">
                      <div
                        class="list-group-item d-flex mb-1 align-items-center"
                        v-for="(comp, index) in selectedPackage.comps"
                        :key="index"
                      >
                        <div class="col-8 text-left small">
                          <div class="font-italic my-1">
                            <span class="text-secondary mr-1">OLAB ID:</span>
                            <span>{{ comp.olab_id }}</span>
                            <span v-if="comp.length" class="ml-3">
                              <span class="text-secondary mr-1">Length:</span>
                              <span>{{ comp.length }}</span>
                            </span>
                          </div>
                          <div class="font-italic my-1">
                            <span v-if="comp.name">
                              <span class="text-secondary mr-1">Name:</span>
                              <span class="mr-3">{{ comp.name }}</span>
                            </span>
                            <span v-if="comp.use_seq_as">
                              <span class="text-secondary mr-1">Use As:</span>
                              <span>{{ comp.use_seq_as }}</span>
                            </span>
                          </div>
                          <div class="font-italic my-1">
                            <span v-if="comp.old_locus_tag">
                              <span class="text-secondary mr-1"
                                >Old Locus Tag:</span
                              >
                              <span>{{ comp.old_locus_tag }}</span>
                            </span>
                            <span v-if="comp.locus_tag" class="ml-3">
                              <span class="text-secondary mr-1"
                                >Locus Tag:</span
                              >
                              <span>{{ comp.locus_tag }}</span>
                            </span>
                          </div>
                          <div class="my-1 text-wrap" v-if="comp.seq">
                            <span class="font-italic text-secondary mr-1"
                              >Sequence:</span
                            >
                            <span class="text-monospace">{{ comp.seq }}</span>
                          </div>
                        </div>

                        <div class="col-4 text-right">
                          <button
                            type="button"
                            class="btn btn-danger"
                            v-on:click="decrItem(comp, index)"
                          >
                            <font-awesome-icon icon="minus" />
                          </button>
                        </div>
                      </div>
                    </div>
                    <div class="py-1 text-right mr-5">
                      <span class="mr-2 text-secondary">Total:</span>
                      <span class="h3">{{ packageQty }}</span>
                    </div>
                  </div>
                </div>
                <!-- .card-body -->
              </div>
              <!-- .card -->
            </div>
            <div class="modal-footer">
              <button
                type="button"
                class="btn btn-secondary"
                data-dismiss="modal"
              >
                Close
              </button>
            </div>
            <!-- .modal-footer -->
          </div>
          <!-- .modal-content -->
        </div>
        <!-- .modal-dialog .modal-lg-->
      </div>
      <!-- .modal fade -- End of packageProfile -->
    </div>
  </div>
</template>

<script>
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { OlabPackage } from "../olab/olabpackage.js";
import { OlabUtils } from "../olab/olabutils.js";
import db from "../olab/db.js";

export default {
  name: "olabpackageprofile",
  props: ["user", "selectedTypeName", "selectedPackage"],
  components: {
    FontAwesomeIcon
  },
  computed: {
    packageQty: function() {
      let qty = 0;
      if (this.selectedPackage != null && this.selectedPackage.comps != null) {
        for (let idx in this.selectedPackage.comps) {
          qty = qty + this.selectedPackage.comps[idx].qty;
        }
      }
      return qty;
    },
    packageIsFull: function() {
      return this.packageQty >= OlabUtils.MAX_ITEMS_PER_PACKAGE ? true : false;
    }
  },
  methods: {
    incrItem: function(item) {
      OlabUtils.infoLog("increment item: qty = " + item.qty);
      item.qty++;
      this.updateSelectedPackage();
    },
    decrItem: function(item, index) {
      OlabUtils.infoLog(
        "decrement item: qty = " + item.qty + ", index = " + index
      );
      if (item.qty > 0) {
        item.qty--;
      }
      if (item.qty == 0) {
        this.selectedPackage.comps.splice(index, 1);
      }
      this.updateSelectedPackage();
    },
    // TODO: refactor this method with a similar one in CompDB.vue
    updateSelectedPackage: function() {
      const pkgRef = "packages/PG/olab_items";
      db.collection(pkgRef)
        .withConverter(OlabPackage.getUpdatePackageConverter())
        .doc(this.selectedPackage.olab_id)
        .set(this.selectedPackage, { merge: true })
        .then(
          function() {
            OlabUtils.infoLog(
              "updateSelectedPackage: Document successfully written!"
            );
          }.bind(this)
        )
        .catch(
          function(error) {
            OlabUtils.infoLog(
              "updateSelectedPackage: Error writing document: ",
              error
            );
            this.error = error;
          }.bind(this)
        );
    }
  }
};
</script>
